import {Component, EventEmitter, Input, input, Output, ChangeDetectionStrategy} from '@angular/core';
import {WaButtonDirective, WaIconDirective} from "angular-awesome";
import {StaffMember} from "../../../../api/models/staff-member";

@Component({
  selector: 'app-supervision-excluded-staff-member',
    imports: [
        WaButtonDirective,
        WaIconDirective
    ],
  templateUrl: './supervision-excluded-staff-member.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './supervision-excluded-staff-member.component.scss',
})
export class SupervisionExcludedStaffMemberComponent {

  staffmember = input.required<StaffMember>();
  @Output() unexclude = new EventEmitter<StaffMember>();

}
